"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _react = _interopRequireWildcard(require("react"));
var _reactCountdownCircleTimer = require("react-countdown-circle-timer");
var _utils = require("../utils");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _default(_ref) {
  var cell = _ref.cell,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent;
  var _cell$timer, _cell$timer2;
  var audio = new Audio(uriTransformer('https://web-treeosk.online/apks/flipcard.mp3'));
  var collectSound = new Audio(uriTransformer('https://web-treeosk.online/apks/collect.mp3'));
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    formSubmitted = _ref3[0],
    setFormSubmitted = _ref3[1];
  var playAudio = function playAudio(volume) {
    audio.volume = volume || 0.5;
    audio.play().catch(function (error) {
      console.error('Error playing audio:', error);
    });
  };
  var playCollectSound = function playCollectSound(volume) {
    collectSound.volume = volume || 0.7;
    collectSound.play().catch(function (error) {
      console.error('Error playing collect sound:', error);
    });
  };
  var _ref4 = (0, _react.useState)([{
      id: 1,
      uri: uriTransformer(cell.card_1_uri),
      flipped: false,
      matched: false
    }, {
      id: 2,
      uri: uriTransformer(cell.card_2_uri),
      flipped: false,
      matched: false
    }, {
      id: 3,
      uri: uriTransformer(cell.card_3_uri),
      flipped: false,
      matched: false
    }, {
      id: 4,
      uri: uriTransformer(cell.card_4_uri),
      flipped: false,
      matched: false
    }, {
      id: 5,
      uri: uriTransformer(cell.card_5_uri),
      flipped: false,
      matched: false
    }, {
      id: 6,
      uri: uriTransformer(cell.card_6_uri),
      flipped: false,
      matched: false
    }, {
      id: 7,
      uri: uriTransformer(cell.card_7_uri),
      flipped: false,
      matched: false
    }, {
      id: 8,
      uri: uriTransformer(cell.card_8_uri),
      flipped: false,
      matched: false
    }]),
    _ref5 = _slicedToArray(_ref4, 2),
    cardStatus = _ref5[0],
    setCardStatus = _ref5[1];
  var _ref6 = (0, _react.useState)(cell.timer || 30),
    _ref7 = _slicedToArray(_ref6, 2),
    timer = _ref7[0],
    setTimer = _ref7[1];
  var _ref8 = (0, _react.useState)({}),
    _ref9 = _slicedToArray(_ref8, 2),
    formData = _ref9[0],
    setFormData = _ref9[1];
  var _ref0 = (0, _react.useState)(0),
    _ref1 = _slicedToArray(_ref0, 2),
    score = _ref1[0],
    setScore = _ref1[1];
  var _ref10 = (0, _react.useState)(false),
    _ref11 = _slicedToArray(_ref10, 2),
    gameStarted = _ref11[0],
    setGameStarted = _ref11[1];
  var _ref12 = (0, _react.useState)(0),
    _ref13 = _slicedToArray(_ref12, 2),
    timerKey = _ref13[0],
    setTimerKey = _ref13[1];
  var _ref14 = (0, _react.useState)(false),
    _ref15 = _slicedToArray(_ref14, 2),
    buttonClicked = _ref15[0],
    setButtonClicked = _ref15[1];
  var _ref16 = (0, _react.useState)(false),
    _ref17 = _slicedToArray(_ref16, 2),
    popUpDommage = _ref17[0],
    setPopUpDommage = _ref17[1];
  var _ref18 = (0, _react.useState)(false),
    _ref19 = _slicedToArray(_ref18, 2),
    gameFinished = _ref19[0],
    setGameFinished = _ref19[1];
  // Refs read by the timer's onComplete, whose closure is frozen at game start
  // (use-elapsed-time re-subscribes only on isPlaying change), so React state there is stale.
  var gameOverRef = (0, _react.useRef)(false);
  var latestRef = (0, _react.useRef)({
    score: 0,
    formData: {}
  });
  latestRef.current = {
    score: score,
    formData: formData
  };
  var _ref20 = (0, _react.useState)({
      label: 'Play',
      score: 'Score',
      dommage: 'Too bad!',
      bravo: 'BRAVO, QUELLE MEMOIRE!',
      dommageText: 'You did not find all pairs in the allotted time'
    }),
    _ref21 = _slicedToArray(_ref20, 2),
    textDatas = _ref21[0],
    setTextDatas = _ref21[1];
  var flipCard = function flipCard(index) {
    playAudio();
    setCardStatus(function (prevStatus) {
      var newStatus = _toConsumableArray(prevStatus);
      newStatus[index].flipped = !newStatus[index].flipped;
      return newStatus;
    });
  };
  (0, _react.useEffect)(function () {
    var duplicateAndShuffle = function duplicateAndShuffle(arr) {
      var duplicatedCards = arr.flatMap(function (card, index) {
        return [_objectSpread(_objectSpread({}, card), {}, {
          uid: "".concat(card.id, "-a")
        }), _objectSpread(_objectSpread({}, card), {}, {
          uid: "".concat(card.id, "-b")
        })];
      });
      for (var i = duplicatedCards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var _ref22 = [duplicatedCards[j], duplicatedCards[i]];
        duplicatedCards[i] = _ref22[0];
        duplicatedCards[j] = _ref22[1];
      }
      return duplicatedCards;
    };
    setCardStatus(duplicateAndShuffle(cardStatus));
  }, []);
  (0, _react.useEffect)(function () {
    var flippedCards = cardStatus.filter(function (card) {
      return card.flipped && !card.matched;
    });
    if (flippedCards.length === 2) {
      if (flippedCards[0].uri === flippedCards[1].uri) {
        setCardStatus(function (prevStatus) {
          return prevStatus.map(function (card) {
            return flippedCards.some(function (fc) {
              return fc.uid === card.uid;
            }) ? _objectSpread(_objectSpread({}, card), {}, {
              matched: true
            }) : card;
          });
        });
        playCollectSound();
        setScore(function (prevScore) {
          return prevScore + 100 + timer;
        });
      } else {
        setTimeout(function () {
          setCardStatus(function (prevStatus) {
            return prevStatus.map(function (card) {
              return flippedCards.some(function (fc) {
                return fc.uid === card.uid;
              }) ? _objectSpread(_objectSpread({}, card), {}, {
                flipped: false
              }) : card;
            });
          });
          playAudio(0.6);
        }, 1000);
      }
    }
  }, [cardStatus]);
  var displayAll5Secondes = function displayAll5Secondes() {
    setCardStatus(function (prevStatus) {
      return prevStatus.map(function (card) {
        return _objectSpread(_objectSpread({}, card), {}, {
          flipped: true
        });
      });
    });
    playAudio(1);
    setTimeout(function () {
      setCardStatus(function (prevStatus) {
        return prevStatus.map(function (card) {
          return _objectSpread(_objectSpread({}, card), {}, {
            flipped: false
          });
        });
      });
      playAudio(1);
    }, 5000);
  };
  (0, _react.useEffect)(function () {
    if (gameStarted) {
      var timerId = setInterval(function () {
        setTimer(function (prevTimer) {
          if (prevTimer <= 0) {
            clearInterval(timerId);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
      return function () {
        return clearInterval(timerId);
      };
    }
  }, [gameStarted]);
  var resetGame = function resetGame() {
    gameOverRef.current = false;
    setTimer(cell.timer || 30);
    setScore(0);
    setCardStatus(cardStatus.map(function (card) {
      return _objectSpread(_objectSpread({}, card), {}, {
        flipped: false,
        matched: false
      });
    }));
    setGameStarted(false);
    setGameFinished(false);
    setButtonClicked(false);
    setTimerKey(function (prevKey) {
      return prevKey + 1;
    });
    setPopUpDommage(false);
  };
  var verifyIsWin = function verifyIsWin() {
    var _cell$game;
    var allMatched = cardStatus.every(function (card) {
      return card.matched;
    });
    if (!allMatched || gameFinished) {
      return;
    }
    gameOverRef.current = true; // stop the timer's onComplete from firing a lose popup
    setGameStarted(false);
    setGameFinished(true);
    var backEndUri = project === null || project === void 0 ? void 0 : project.backEndUri;
    var gameId = cell === null || cell === void 0 || (_cell$game = cell.game) === null || _cell$game === void 0 ? void 0 : _cell$game.id;
    if (backEndUri && gameId) {
      _axios.default.post("".concat(backEndUri, "/play/").concat(gameId), {
        player_data: _objectSpread(_objectSpread({}, formData), {}, {
          score: score
        })
      }).catch(function (error) {
        console.error('CardsGame success submit failed:', error);
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (popUpDommage) {
      return;
    }
    verifyIsWin();
  }, [cardStatus]);
  if (!cell) {
    return;
  }
  (0, _react.useEffect)(function () {
    if (intl) {
      switch (intl.locale) {
        case 'fr':
          setTextDatas({
            label: 'Jouer',
            score: 'Score',
            dommage: 'DOMMAGE!',
            bravo: 'BRAVO, QUELLE MEMOIRE!',
            dommageText: 'Vous n’avez pas trouvé toutes les paires dans le temps imparti'
          });
          break;
        case 'en':
          setTextDatas({
            label: 'Play',
            score: 'Score',
            dommage: 'DOMMAGE!',
            bravo: 'BRAVO, QUELLE MEMOIRE!',
            dommageText: 'You did not find all pairs in the allotted time'
          });
          break;
        case 'nl':
          setTextDatas({
            label: 'Spelen',
            score: 'Score',
            dommage: 'Jammer!',
            bravo: 'GEFELICITEERD!',
            dommageText: 'Je hebt niet alle paren gevonden in de beschikbare tijd'
          });
          break;
        case 'de':
          setTextDatas({
            label: 'Spielen',
            score: 'Punktestand',
            dommage: 'Schade!',
            bravo: 'HERZLICHEN GLÜCKWUNSCH!',
            dommageText: 'Du hast nicht alle Paare in der vorgegebenen Zeit gefunden'
          });
          break;
        default:
          setTextDatas({
            label: 'Play',
            score: 'Score',
            dommage: 'Too bad!',
            bravo: 'BRAVO, QUELLE MEMOIRE!',
            dommageText: 'You did not find all pairs in the allotted time'
          });
      }
    }
  }, [intl, defaultLanguage]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      top: '0',
      left: '0',
      width: '100%',
      display: 'flex',
      textAlign: 'center',
      zIndex: 1,
      flexDirection: 'column',
      padding: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "@keyframes pulse {\n                            0% { transform: scale(1); }\n                            50% { transform: scale(1.08); }\n                            100% { transform: scale(1); }\n                        }\n\n                        .btn-start {\n                            animation: pulse 1.4s infinite;\n                            transform-origin: center;\n                        }\n                        "), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactCountdownCircleTimer.CountdownCircleTimer, {
    key: timerKey,
    onComplete: function onComplete() {
      var _cell$game2;
      // gameOverRef (not the stale gameFinished closure) reflects a win
      if (gameOverRef.current) {
        return;
      }
      setPopUpDommage(true);
      var backEndUri = project === null || project === void 0 ? void 0 : project.backEndUri;
      var gameId = cell === null || cell === void 0 || (_cell$game2 = cell.game) === null || _cell$game2 === void 0 ? void 0 : _cell$game2.id;
      if (backEndUri && gameId) {
        var _latestRef$current = latestRef.current,
          latestScore = _latestRef$current.score,
          latestFormData = _latestRef$current.formData;
        _axios.default.post("".concat(backEndUri, "/play/").concat(gameId), {
          player_data: _objectSpread(_objectSpread({}, latestFormData), {}, {
            score: latestScore
          })
        }).catch(function (error) {
          console.error('CardsGame timeout submit failed:', error);
        });
      }
      setTimeout(function () {
        resetGame();
      }, 3000);
    },
    isPlaying: gameStarted && timer >= 0 && !gameFinished && !popUpDommage,
    duration: Number((_cell$timer = cell === null || cell === void 0 ? void 0 : cell.timer) !== null && _cell$timer !== void 0 ? _cell$timer : 30),
    durationSeconds: Number((_cell$timer2 = cell === null || cell === void 0 ? void 0 : cell.timer) !== null && _cell$timer2 !== void 0 ? _cell$timer2 : 30),
    size: window.innerWidth < 600 ? 40 : 100,
    colors: [[cell.timer_color_1 || '#2B5A2F', 0.33], [cell.timer_color_2 || '#FEC700', 0.33], [cell.timer_color_3 || '#EF645B', 0.33]],
    strokeWidth: window.innerWidth < 600 ? 4 : 10
  }, function (_ref23) {
    var remainingTime = _ref23.remainingTime;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontSize: '1.2em',
        fontWeight: 'bold'
      }
    }, remainingTime, "s");
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: '1.2em',
      marginTop: '0.5em',
      color: 'white'
    }
  }, textDatas.score + ': ' + score))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      padding: '0.4em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '10px'
    }
  }, cardStatus.map(function (card, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: card.uid || index,
      className: "card-container",
      style: {
        padding: '0.2em',
        height: '16vh',
        maxHeight: '16vh',
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-inner ".concat(card.flipped || card.matched ? 'flipped' : '')
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: uriTransformer(cell.verso_uri),
      alt: "Back",
      className: "card-face card-back",
      style: {
        height: '100%',
        width: '100%',
        objectFit: 'contain'
      },
      onClick: function onClick() {
        if (popUpDommage) return;
        if (!gameStarted) return;
        if (card.flipped || card.matched) return;
        if (cardStatus.filter(function (c) {
          return c.flipped && !c.matched;
        }).length >= 2) return;
        flipCard(index);
      }
    }), /*#__PURE__*/_react.default.createElement("img", {
      src: card.uri,
      alt: "Card ".concat(card.id),
      className: "card-face card-front",
      style: {
        height: '100%',
        width: '100%',
        objectFit: 'contain'
      }
    })));
  }))), !gameStarted && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn-start",
    onClick: function onClick() {
      displayAll5Secondes();
      setButtonClicked(true);
      setTimeout(function () {
        setGameStarted(true);
      }, 5000);
    },
    style: {
      background: cell.btn_start_color || '#2B5A2F',
      opacity: buttonClicked ? 0 : '0.9',
      backdropFilter: 'blur(5px)',
      color: cell.btn_start_text_color || 'white',
      borderRadius: '50%',
      border: 'solid 0.1em white',
      cursor: 'pointer',
      width: '25vw',
      height: '25vw',
      position: 'absolute',
      top: '45%',
      left: '38%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      fontSize: '2.8em',
      zIndex: 50
    }
  }, textDatas.label), !formSubmitted && cell.fields && cell.fields.find(function (field) {
    return field.visible;
  }) && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#FFF',
      textAlign: 'center',
      zIndex: 100,
      background: 'rgba(0, 0, 0, 0.7)',
      padding: '1em',
      borderRadius: '0.5em',
      width: '80vw'
    }
  }, /*#__PURE__*/_react.default.createElement("form", null, cell.fields.map(function (field) {
    if (field.visible) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: field.id,
        style: {
          marginBottom: '0.5em'
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        style: {
          fontWeight: 'bold'
        }
      }, (0, _utils.i18nData)(field, 'label', intl, defaultLanguage), ":"), (field.type === 'short_text' || field.type === 'email' || field.type === 'integer' || field.type === 'date') && /*#__PURE__*/_react.default.createElement("input", {
        required: field.required,
        type: field.type === 'email' ? 'email' : field.type === 'integer' ? 'number' : field.type === 'date' ? 'date' : 'text',
        value: formData[field.name] || '',
        onChange: function onChange(e) {
          return setFormData(_objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, field.name, e.target.value)));
        },
        style: {
          marginLeft: '0.5em',
          padding: '0.2em',
          borderRadius: '0.2em',
          border: '1px solid #ccc'
        }
      }), field.type === 'select' && /*#__PURE__*/_react.default.createElement("select", {
        required: field.required,
        value: formData[field.name] || '',
        onChange: function onChange(e) {
          return setFormData(_objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, field.name, e.target.value)));
        },
        style: {
          marginLeft: '0.5em',
          padding: '0.2em',
          borderRadius: '0.2em',
          border: '1px solid #ccc'
        }
      }, /*#__PURE__*/_react.default.createElement("option", {
        value: ""
      }, (0, _utils.i18nData)(field, 'label', intl, defaultLanguage)), field.options.map(function (option) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: option.id,
          value: option.value
        }, option.label);
      })), field.type === 'multiple' && /*#__PURE__*/_react.default.createElement("select", {
        required: field.required,
        value: formData[field.name] || '',
        onChange: function onChange(e) {
          return setFormData(_objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, field.name, e.target.value)));
        },
        style: {
          marginLeft: '0.5em',
          padding: '0.2em',
          borderRadius: '0.2em',
          border: '1px solid #ccc'
        },
        multiple: true
      }, field.options.map(function (option) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: option.id,
          value: option.value
        }, option.label);
      })));
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    onClick: function onClick(e) {
      e.preventDefault();
      resetGame();
      setFormSubmitted(true);
    },
    style: {
      background: '#2B5A2F',
      color: 'white',
      borderRadius: '0.2em',
      border: 'none',
      padding: '0.5em 1em',
      cursor: 'pointer'
    }
  }, "Commencer le jeu")))), gameFinished && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '60vw',
      minHeight: '12vh',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#FFF',
      color: '#30130D',
      textAlign: 'center',
      padding: '1.5em',
      borderRadius: '0.5em',
      zIndex: 150,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("h1", {
    style: {
      color: 'rgb(14, 37, 57)',
      margin: 0,
      lineHeight: '3rem',
      fontWeight: 'bold',
      fontSize: '2em'
    }
  }, textDatas.bravo)), popUpDommage && !gameFinished && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '60vw',
      minHeight: '15vh',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#FFF',
      color: '#30130D',
      textAlign: 'center',
      padding: '1.5em',
      borderRadius: '0.5em',
      zIndex: 150,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("h1", {
    style: {
      color: 'rgb(14, 37, 57)',
      margin: 0,
      marginBottom: '0.4em',
      lineHeight: '3rem',
      fontWeight: 'bold',
      fontSize: '2em'
    }
  }, textDatas.dommage), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: '#35653E',
      fontSize: '1em',
      marginTop: '1.2em',
      fontWeight: 'bold'
    }
  }, textDatas.dommageText)));
}